import React, { Fragment, useState } from "react";

import FormGrouping from "../../../components/forms/FormGrouping";
import CheckboxGroupService from "../../../services/form/CheckboxGroupService";

import "./FormExportarExcel.scss";

export default function FormExportarPag({ result, caracteristicasDefault }) {
  const [consulta, setConsulta] = useState("");
  const [selectedIdentificacoes, setIdentificacoes] = useState([]);
  const [selectedGenealogia, setSelectedGenealogia] = useState([]);
  const [selectedReguaDeps, setSelectedReguaDeps] = useState([]);
  const [selectedNumeroDeFilhos, setSelectedNumeroDeFilhos] = useState([]);
  const [selectedPeso, setSelectedPeso] = useState([]);
  const [selectedDeps, setSelectedDeps] = useState([]);

  const identificacoes = [
    "Série",
    "Raça",
    "Variedade",
    "Situação",
    "RGN",
    "Categoria",
    "Sexo",
    "NFA",
    "RGD",
    "Data de Nascimento",
    "Nome",
    "NFO",
  ];
  const genealogia = ["Pai", "Avô Paterno", "Mãe", "Avô Materno"];
  const reguaDeps = ["DEP", "Percentil", "Acurácia"];
  const numeroDeFilhos = [
    "NF3P",
    "NFSTAY",
    "NF450",
    "NFUS",
    "NFSAMS",
    "NN120",
    "NF120",
    "NR210",
    "NR450",
    "NRUS",
    "NRN120",
    "NR120",
  ];
  const peso = ["P120", "P210", "P365", "P450", "PE365", "PE450"];

  const getAsOptions = (options, handleFunction, propertyToShow) => {
    return (Array.isArray(options) ? options : []).map((option, i) => {
      return (
        <div className="global-checkbox-input" key={i}>
          <input
            type="checkbox"
            id={i}
            key={i}
            onChange={(e) => handleFunction(option)}
          ></input>
          <label>{propertyToShow ? option[propertyToShow] : option}</label>
        </div>
      );
    });
  };

  const handleIdentificacao = (option) => {
    const newIdentificacoes = CheckboxGroupService.getSelectedUpdated(
      selectedIdentificacoes,
      option
    );
    setIdentificacoes(newIdentificacoes);
    setConsulta({ ...consulta, identificacoes: selectedIdentificacoes });
  };

  const handleGenealogia = (option) => {
    const newGenealogia = CheckboxGroupService.getSelectedUpdated(
      selectedGenealogia,
      option
    );
    setSelectedGenealogia(newGenealogia);
    setConsulta({ ...consulta, deps: selectedGenealogia });
  };

  const handleReguaDeps = (option) => {
    const newReguaDeps = CheckboxGroupService.getSelectedUpdated(
      selectedReguaDeps,
      option
    );
    setSelectedReguaDeps(newReguaDeps);
    setConsulta({ ...consulta, deps: selectedReguaDeps });
  };

  const handleNumeroDeFilhos = (option) => {
    const newNumeroDeFilhos = CheckboxGroupService.getSelectedUpdated(
      selectedNumeroDeFilhos,
      option
    );
    setSelectedNumeroDeFilhos(newNumeroDeFilhos);
    setConsulta({ ...consulta, deps: selectedNumeroDeFilhos });
  };

  const handlePeso = (option) => {
    const newPeso = CheckboxGroupService.getSelectedUpdated(
      selectedPeso,
      option
    );
    setSelectedPeso(newPeso);
    setConsulta({ ...consulta, deps: selectedPeso });
  };

  const handleDEPS = (option) => {
    const newDeps = CheckboxGroupService.getSelectedUpdated(
      selectedDeps,
      option,
      "caracteristicaId"
    );
    setSelectedDeps(newDeps);
    setConsulta({ ...consulta, deps: selectedDeps });
  };

  const handleSubmit = () => {
  };

  return (
    <Fragment>
      {result && result.length === 0 && <h3 className="mt-4">Faça a consulta na aba filtro</h3>}

      {result && result.length > 0 && (
        <Fragment>
          <div className="btn-container">
            <a href="/submodulos/2" className="global-btn-info">
              Voltar
            </a>
            <button className="global-btn-info" onClick={handleSubmit}>
              Pesquisar
            </button>
          </div>
          <FormGrouping title="Identificação">
            <div className="excel-export-grid">
              {getAsOptions(identificacoes, handleIdentificacao)}
            </div>
          </FormGrouping>
          <FormGrouping title="Genealogia">
            <div className="excel-export-grid">
              {getAsOptions(genealogia, handleGenealogia)}
            </div>
          </FormGrouping>
          <FormGrouping title="DEPS">
            <div className="excel-export-grid">
              {getAsOptions(
                caracteristicasDefault,
                handleDEPS,
                "caracteristicaDescricao"
              )}
            </div>
          </FormGrouping>
          <FormGrouping title="Personalizar Régua de DEPS">
            <div className="excel-export-grid">
              {getAsOptions(reguaDeps, handleReguaDeps)}
            </div>
          </FormGrouping>
          <FormGrouping title="Número de Filhos / Rebanhos">
            <div className="excel-export-grid">
              {getAsOptions(numeroDeFilhos, handleNumeroDeFilhos)}
            </div>
          </FormGrouping>
          <FormGrouping title="Peso Padronizado">
            <div className="excel-export-grid">
              {getAsOptions(peso, handlePeso)}
            </div>
          </FormGrouping>
        </Fragment>
      )}
    </Fragment>
  );
}
